<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="close" :class="{loading : isLoading}">

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body" v-if="!isLoading">
            <slot name="body">
              default body
            </slot>
          </div>
          <div class="modal-loader" v-if="isLoading">
            <div class="flex flex-just-center">
              <i class="material-icons">cached</i>
              <span>{{$resx('PleaseWaitText')}}</span>
            </div>
          </div>

          <!--<div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>-->
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import clickOutside from '../directives/click-outside'

export default {
  props: {
    isLoading: Boolean
  },
  methods:
  {
    close: function () {
      if (!this.isLoading) {
        this.$emit('close')
      }
    }
  },
  directives: {
    'click-outside': clickOutside
  }
}
</script>
<style lang="less" >
  @import '../assets/variables.less';

  .modal-mask {
    position: fixed;
    z-index: 9000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .75);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 80%;
    max-height:95vh;
    overflow-y:auto;
    margin: 0px auto;
    padding: 3em 2.5em;
    background-color: @dark;
    box-shadow: 0px 0px 10px 4px rgba(10,10,10,.5);
    transition: all .3s ease;

    &.loading
    {
      max-width:45em!important;
    }

    .modal-header > h3 {
      margin: 0 auto .5em auto;
      color: @white;
      font-weight: @fontBlack;
      font-size: 3em;
      text-align: center;
    }

    .modal-body, .modal-loader {
      margin: 20px 0;
    }

    .modal-loader {
      span
      {
        font-size: 1.5em;
        line-height: 1.5em;
      }

      i {
        font-size: 4em;
        transform-origin: center center;
        animation: rotate 1.5s linear infinite;
      }
    }
  }

  /*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes translate-rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg) ;
    }

    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
</style>
